import { Box, Button, Divider, IconButton, Link, Typography } from "@mui/material";
import React, { useEffect } from "react";
import { connect } from "react-redux";
import { Link as RouterLink } from 'react-router-dom'
import { AnyAction, Dispatch } from "redux";
import { StoreState } from "../../../../state/configureStore";
import { padding } from "../../../../theme";
import { HorizontalSpacer } from "../../../atoms/spacer";
import { TextTitle } from "../../../atoms/text/titles";
import { Close, WidthFull } from '@mui/icons-material'
import { closedMapPopup } from "../../../../state/actions/map";
import { FoundStoreProps } from "./dashboardMap";
import CustomButton from "../../button";

const LinkLabel = ({ isMobile, path, linkText, label }: { isMobile: boolean, path: string, linkText: string | undefined, label: string }) => {
  return (
    <Typography variant={isMobile ? 'body2' : 'body1'}>
      <>{label}</>
      {linkText ? (
        <Link component={RouterLink}
          to={path}>{linkText}</Link>
      ) : (
        '-'
      )
      }
    </Typography>
  )
}

const StoreMapPopup = (state: FoundStoreProps & ReturnType<typeof mapStateToProps> & ReturnType<typeof mapDispatchToProps>) => {

  if (!state.store) return null

  const isMobile = state.dimensions.device === "mobile"
  const isDesktop = state.dimensions.device === "desktop"
  const storeName = state.store.name
  const ownerName = state.store?.parentName;
  const ownerId = state.store?.parentId;

  return (

    <Box style={{
      padding: padding * 1.5,
      display: 'flex',
      flexDirection: 'column',
    }}>
      <Box style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
        <TextTitle title={storeName || "Store Details"} />

        {isDesktop ? null : <IconButton sx={{ alignSelf: 'flex-start', padding: 0 }} onClick={() => state.closedMapPopup(state.store.id)}>
          <Close />
        </IconButton>}
      </Box>
      <Divider /><HorizontalSpacer />
      <Typography variant={isMobile ? 'body2' : 'body1'}>{'Number of hubs: ' + state.store?.machineCount}</Typography>
      <HorizontalSpacer /><Divider /><HorizontalSpacer />
      <Typography variant={isMobile ? 'body2' : 'body1'}>{'Address: ' + state.store?.visitingAddress?.addressLine1}</Typography>
      <HorizontalSpacer /><Divider /><HorizontalSpacer />
      
      {ownerId && ownerName &&(
        <>
          <LinkLabel isMobile={isMobile} path={`/customers/${ownerId}`} linkText={ownerName} label="Owned by: " />
          <HorizontalSpacer /><Divider /><HorizontalSpacer />
        </>
      )}
      
      <Link fontSize={isMobile ? 14 : '1rem'} style={{ paddingTop: padding, display: "flex", justifyContent: "center", textDecoration: "none" }} component={RouterLink} to={`/customers/${state.store.id}`}>
          <Button>{'Go to store page'}</Button>
      </Link>
    </Box>
  );
};

const mapStateToProps = (state: StoreState) => ({
  dimensions: state.dimensions
})

const mapDispatchToProps = (dispatch: Dispatch<AnyAction>) => ({

  closedMapPopup: (id: string) => dispatch(closedMapPopup(id)),
})

export default connect(mapStateToProps, mapDispatchToProps)(StoreMapPopup)